//! local config — copy from local.ts.dev / local.ts.prod as needed

export const [BASE_URL] = [
  "https://fssiaapi.fnsyrus.com",
]
export const [BASE_URL_VIDEO] = [
  "https://fssia-event.fnsyrus.com",
]
export const DEBUG = false
